// extracted by mini-css-extract-plugin
export var deleteIcon = "_st-5";
export var deleteOption = "_st-3";
export var divider = "_st-2";
export var downloadIcon = "_st-4";
export var drawer = "_st-0";
export var drawerFooter = "_st-6";
export var drawerOpen = "_st-1";
export var highlighted = "_st-7";
export var lighterHighlight = "_st-8";